var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"card"},[_c('span',[_vm._v(_vm._s(_vm.number))]),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._t("title",[_vm._v(_vm._s(_vm.text))])],2),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._t("text",[_vm._v(_vm._s(_vm.text))])],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2719c8c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/Card.vue
// module id = 1172
// module chunks = 0